jQuery(function($) {
    var defaultNlPref = 'alert';

    var nlSectionMap = {
        'news/local'           : 'daily',
        'news/obits'           : 'obits',
        'entertainment'        : 'entertainment',
        'business/realestate'  : 'at-home',
        'lifestyle'            : 'at-home',
        'sports'               : 'first-pitch'
    };

    var sectionIterator = function(section) {
        if(typeof pageSection !== 'undefined') {
            if(typeof nlSectionMap[section] !== 'undefined')
                return nlSectionMap[section];

            section = section.split('/');
            section.pop();
            section = section.join('/');

            if(section.length)
                return sectionIterator(section);
        }
        return defaultNlPref;
    }

    var getNewsletterOfferId = function() {
        var locationData = JSON.parse(localStorage.GlobalLocation || JSON.stringify({})),
            city = locationData.city || false,
            state = locationData.stateProvCode || false;

        if(state === 'CA' && city === 'Healdsburg') return 65;
        return sectionIterator(pageSection);
    }

    var nlPref = getNewsletterOfferId(pageSection),
        promoSlot = $('#inline-promo, #inline-promo-end').filter(':empty').first();

    promoSlot.addClass('article-inline-promo-right').removeClass('padded').html('<div style="padding: .65em; background-color: #EFEFEF;"><script src="https://newsletter.pressdemocrat.com/widget/single/pref:' + nlPref + ';hideImage:1/script.js"></script></div>');
});